import API from 'services/TAPS_API/index';
import { moment } from 'utils';

export default function relatedAppeals(cardId) {
  return API.request({
    method: 'GET',
    url: `/notification/1112520/relatedList`,
    params: {
      cardId,
    },
    mapper: function (data) {
      //note: dates in 'DD.MM.YYYY HH:mm:SS', use moment.fromFullDatetime(dateString)
      return data
        .map((relatedAppeal) => {
          return Object.assign({}, relatedAppeal, {
            date: moment.fromFullDatetime(relatedAppeal.receiptDate),
          });
        })
        .sort((appeal1, appeal2) => {
          return appeal1.date.isBefore(appeal2.date) ? 1 : -1;
        });
    },
  });
}
